import { Minus, Plus } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { BarControl } from "./BarControl";
import type { QuantityControlProps } from "./types";

export function QuantityControl({
  quantity,
  onQuantityChange,
}: QuantityControlProps) {
  const { t } = useLanguage();

  return (
    <BarControl as="div">
      <span className="text-white/60 text-xs sm:text-sm hidden sm:inline">
        {t.generate.quantity}
      </span>
      <div className="flex items-center gap-1">
        <button
          onClick={() => onQuantityChange(Math.max(1, quantity - 1))}
          className="w-7 h-7 rounded-lg bg-white/[0.06] hover:bg-white/[0.14] flex items-center justify-center text-white/70 hover:text-white/90 transition-all"
        >
          <Minus className="w-4 h-4" />
        </button>
        <span className="w-6 text-center text-white font-bold text-sm">
          {quantity}
        </span>
        <button
          onClick={() => onQuantityChange(Math.min(4, quantity + 1))}
          className="w-7 h-7 rounded-lg bg-white/[0.06] hover:bg-white/[0.14] flex items-center justify-center text-white/70 hover:text-white/90 transition-all"
        >
          <Plus className="w-4 h-4" />
        </button>
      </div>
    </BarControl>
  );
}
